import { FC, ChangeEvent } from 'react'

import styled from 'styled-components'

import { numberFormatCommas } from 'src/Constants/functions'

import { Avatar } from '../Avatar'
import { PremiumCheckbox } from '../PremiumCheckbox'

interface ManualMatchingCuratorItemProps {
  curatorName: string
  playlistsCount: number
  amountPerSubmission: string
  avatarUrl?: string | null
  checked?: boolean
  onCheckboxChange?: (checked: boolean) => void
}

const Container = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  background-color: ${({ theme }) => theme.color.white};
`

const AvatarContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`

const InfoContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
  flex: 1;
  min-width: 0;
`

const CuratorName = styled.p`
  font-family: 'Segoe UI', sans-serif;
  font-weight: 600;
  font-size: 16px;
  line-height: 1.5;
  color: ${({ theme }) => theme.color.darkGrey};
  margin: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`

const MetadataWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  font-family: 'Segoe UI', sans-serif;
  font-weight: 400;
  font-size: 14px;
  line-height: 1.5;
  color: ${({ theme }) => theme.color.darkGrey};
`

const MetadataItem = styled.span`
  display: flex;
  gap: 4px;
  white-space: nowrap;
`

const PriceContainer = styled.div`
  font-family: 'Segoe UI', sans-serif;
  line-height: 1.5;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  margin-left: auto;
  color: ${({ theme }) => theme.color.darkGrey};
`

const Price = styled.p`
  font-weight: 600;
  font-size: 16px;
  margin: 0;
`

const PriceLabel = styled.span`
  font-weight: 400;
  font-size: 12px;
`
const DEFAULT_COVER_SIZE = 48

export const ManualMatchingCuratorItem: FC<ManualMatchingCuratorItemProps> = ({
  curatorName,
  playlistsCount,
  avatarUrl,
  amountPerSubmission,
  checked,
  onCheckboxChange,
}) => {
  const formattedPlaylistsCount = numberFormatCommas(playlistsCount)
  const playlistText = playlistsCount === 1 ? 'playlist' : 'playlists'

  const handleCheckboxChange = (e: ChangeEvent<HTMLInputElement>): void => {
    e.stopPropagation()
    onCheckboxChange?.(e.target.checked)
  }

  return (
    <Container>
      <AvatarContainer>
        <PremiumCheckbox
          checked={checked}
          onChange={handleCheckboxChange}
          onClick={(e) => e.stopPropagation()}
        />
        <Avatar
          src={avatarUrl ?? ''}
          width={DEFAULT_COVER_SIZE}
          height={DEFAULT_COVER_SIZE}
        />
      </AvatarContainer>

      <InfoContainer>
        <CuratorName>{curatorName}</CuratorName>
        <MetadataWrapper>
          <MetadataItem>
            {formattedPlaylistsCount} {playlistText}
          </MetadataItem>
        </MetadataWrapper>
      </InfoContainer>

      <PriceContainer>
        <Price>{amountPerSubmission}</Price>
        <PriceLabel>per submission</PriceLabel>
      </PriceContainer>
    </Container>
  )
}
